import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import i18n from 'i18n-js';
import PropTypes from 'prop-types';

import FONT_FAMILY from '../../../constants/fontFamily';
import FontFamilyHeader from '../../FontFamilyHeader';
import { AlertContainer, Message, Title } from './styles';
import { overlayRemoveAlert } from '../../../reducers/Overlay/actions';

function AlertBoxSimple({ data, isBuilder, styles }) {
  const mockAlert = {
    amount: 10,
    currency: 'usd',
    message: i18n.t('screens.builder.build.alertbox.mockMessage'),
    username: 'OverlayOn',
  };
  const [isShowing, setIsShowing] = useState(false);
  const [isShowingAnimation, setIsShowingAnimation] = useState(false);
  const [currentAlert, setCurrentAlert] = useState(
    !isBuilder ? null : mockAlert
  );
  const dispatch = useDispatch();
  const { alerts } = useSelector((state) => state.overlay);
  const {
    overlayonMarathon: { template: overlayonMarathonTemplate },
    status,
  } = data;
  const { message, title } = styles || {};
  const locale = navigator.language || navigator.userLanguage;

  const fontFamilyMessage = FONT_FAMILY[styles?.message?.font || 'notoSans'];
  const fontFamilyTitle = FONT_FAMILY[styles?.title?.font || 'notoSans'];

  useEffect(() => {
    if (status === 'paused' || isShowing || !alerts?.length) return;

    setIsShowing(true);
    setIsShowingAnimation(true);

    const [firstAlert] = alerts;
    setCurrentAlert(firstAlert);
    dispatch(overlayRemoveAlert(firstAlert.id));

    setTimeout(() => setIsShowingAnimation(false), 5000);
    setTimeout(() => {
      setCurrentAlert(null);
      setIsShowing(false);
    }, 6000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(alerts), isShowing, status, dispatch]);

  return (
    <>
      <FontFamilyHeader family={fontFamilyMessage} />
      <FontFamilyHeader family={fontFamilyTitle} />
      {((currentAlert && isShowing) || isBuilder) && (
        <>
          <AlertContainer show={isShowingAnimation}>
            <Title
              dangerouslySetInnerHTML={{
                __html: overlayonMarathonTemplate
                  .replace(
                    '{username}',
                    `<span style="color: ${title?.primary}">${currentAlert?.username}</span>`
                  )
                  .replace(
                    '{amount}',
                    `<span style="color: ${
                      title?.primary
                    }">${currentAlert?.amount.toLocaleString(locale, {
                      style: 'currency',
                      currency: currentAlert?.currency,
                    })}</span>`
                  ),
              }}
              style={{
                color: title?.color,
                fontFamily: fontFamilyTitle?.family,
                fontSize: title?.size,
                letterSpacing: title?.letterSpacing,
                lineHeight: title?.size ? `${title?.size}px` : undefined,
              }}
            />
            <Message
              style={{
                color: message?.color,
                fontFamily: fontFamilyMessage?.family,
                fontSize: message?.size,
                letterSpacing: message?.letterSpacing,
                lineHeight: message?.size ? `${message?.size}px` : undefined,
              }}
            >
              {currentAlert?.message}
            </Message>
          </AlertContainer>
        </>
      )}
    </>
  );
}

AlertBoxSimple.propTypes = {
  data: PropTypes.shape({
    alerts: PropTypes.arrayOf(PropTypes.number),
    overlayonMarathon: PropTypes.shape({
      template: PropTypes.string,
    }),
    status: PropTypes.bool,
  }),
  styles: PropTypes.shape({
    message: PropTypes.shape({
      color: PropTypes.string,
      font: PropTypes.string,
      letterSpacing: PropTypes.number,
      size: PropTypes.number,
    }),
    title: PropTypes.shape({
      color: PropTypes.string,
      font: PropTypes.string,
      letterSpacing: PropTypes.number,
      primary: PropTypes.string,
      size: PropTypes.number,
    }),
  }),
};

AlertBoxSimple.defaultProps = {
  data: {
    overlayonMarathon: {
      minAmount: 2,
      template: 'New %{amount} donation received from %{username}!',
    },
    status: 'playing',
  },
  styles: {
    message: {
      color: '#ffffff',
      font: 'notoSans',
      letterSpacing: 0,
      size: 24,
    },
    title: {
      color: '#ffffff',
      font: 'notoSans',
      letterSpacing: 0,
      primary: '#A760FF',
      size: 48,
    },
  },
};

export default AlertBoxSimple;
